import React, { Fragment, useEffect, useRef, useState } from "react";

interface StickyHeaderProps {
    children: any;
}

let StickyHeader = ({ children }: StickyHeaderProps) => {
    const [isSticky, setSticky] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const handleScroll = () => {
        if (ref.current) {
            setSticky(ref.current.getBoundingClientRect().top <= 0);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", () => handleScroll);
        };
    }, []);

    return (
        <Fragment>
            <div
                className={`sticky-wrapper${isSticky ? " sticky" : ""}`}
                ref={ref}
            >   
                <div className="sticky-inner">
                {children}
                </div>
            </div>
        </Fragment>
    );
};

export default StickyHeader;